import { render } from "./PrintInvoiceMoneyDetailsDesign4.vue?vue&type=template&id=2aa01172"
import script from "./PrintInvoiceMoneyDetailsDesign4.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceMoneyDetailsDesign4.vue?vue&type=script&lang=js"

import "./PrintInvoiceMoneyDetailsDesign4.vue?vue&type=style&index=0&id=2aa01172&scoop=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__